import { useState } from "react";
import { Heart, X } from "lucide-react";
import { patternBg } from "@/lib/patternBg";

const KEY = "bb-aviso-prazo";
const seen = () => {
  try { return sessionStorage.getItem(KEY) === "1"; } catch { return false; }
};

// Aviso discreto, em todas as páginas: os artigos são feitos pela Alexandra por encomenda (o texto fala na primeira pessoa).
export const AnnouncementBar = () => {
  const [hidden, setHidden] = useState(seen);
  if (hidden) return null;
  const close = () => {
    try { sessionStorage.setItem(KEY, "1"); } catch { /* sem armazenamento: só fecha desta vez */ }
    setHidden(true);
  };
  return (
    <div className="relative bg-rose-soft text-ink" style={patternBg("vichy-rosa-claro", "245,235,233", 0.8, 160)} data-testid="announcement-bar" role="note">
      <div className="bb-container flex min-h-[36px] items-center justify-center gap-2 py-1.5 pr-9 text-center text-[11.5px] leading-snug sm:text-[13px]">
        <Heart className="hidden h-3.5 w-3.5 shrink-0 text-bordeaux sm:block" aria-hidden="true" />
        <p><strong className="font-semibold">Artigos feitos pela Alexandra, por encomenda</strong></p>
        <button type="button" onClick={close} aria-label="Fechar aviso" data-testid="announcement-close" className="absolute right-1 top-1/2 grid h-9 w-9 -translate-y-1/2 place-items-center rounded-full text-taupe-strong hover:bg-ivory/70 sm:right-3">
          <X className="h-4 w-4" aria-hidden="true" />
        </button>
      </div>
    </div>
  );
};
